import axios from 'axios'
import library from '../../../utils/Library'

export const helpEditOrganizationCorpEntities = async (organization) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('organization') + '/updateOrganizationCorpEntities'

  return await axios({
    url: URL,
    method: 'POST',
    data: {
      organizationId: organization.organizationId,
      values: {
        organizationName: organization.organizationName,
        organizationLegalName: organization.organizationlegalName,
        organizationTypeId: organization.organizationTypeId,
        organizationMaxAccessCount: organization.organizationMaxAccessCount,
        organizationCuit: organization.organizationCuit
      }
    },
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
